import {Module} from 'vuex';

/** @type {Module}
 */
const contact = {
    namespaced: true,
    state: {
        phone: '',
        email: '',
        isShowPasswordForm: false,
        is_promotionable: true,
    },
    mutations: {
        setPhone: (state, value) => state.phone = value,
        setEmail: (state, value) => state.email = value,
        setIsShowPasswordForm: (s, p) => s.isShowPasswordForm = p
    }
};

export default contact;
